import React from 'react';

export default function AlertsBar({ alerts }) {
  if (!alerts || alerts.length === 0) return null;

  const top3 = alerts.slice(0, 3);
  const text = top3.map(a =>
    `${a.site_name}: "${a.keyword}" ירד ${a.drop} מקומות (${a.old_position} → ${a.new_position})`
  ).join(' · ');

  return (
    <div className="alerts-bar animate-in">
      <svg width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
        <path d="M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0zM12 9v4m0 4h.01"/>
      </svg>
      <div className="alert-text">{text}</div>
      <span className="alert-count">{alerts.length} התראות</span>
    </div>
  );
}
